var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns list-stats"},_vm._l((_vm.statIds),function(stat_id){return _c('div',{key:stat_id,staticClass:"column col-4 col-lg-4 col-md-6 col-sm-12"},[_vm._t("default",null,{"id":stat_id,"waiting":_vm.loading,"data":_vm.stats})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }